import ZelleScreen from 'features/moveMoney/screens/Zelle/ZelleScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function Page() {
  return (
    <PinwheelContextProvider>
      <ZelleScreen />
    </PinwheelContextProvider>
  );
}
